import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { SectionCard } from 'src/components/shared/SectionCard'

interface Props {
  legalName: string
}

/** The master contractor this contractor works under, when there is one. */
const McLiteCardComponent = ({ legalName }: Props) => {
  return (
    <SectionCard title="Master contractor" dataTestId="document-review-mclite-card">
      <Typography variant="body2" css={tw`text-shades-900`}>
        {legalName}
      </Typography>
    </SectionCard>
  )
}

export const McLiteCard = memo(McLiteCardComponent)
